import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Table,
  UncontrolledDropdown,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import CompanyService from "../../../services/companyService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ContactService from "../../../services/contactService";
import _ from "lodash";
import FormInput from "../../../components/common/form/FormInput";
import {
  CompanyPermissions,
  ContactPermissions,
  ContentPermissions, MeetingReportPermissions,
} from "../../../services/permissions";
import formatFrontendDate from "../util/formatFrontendDate";

class CompanyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      filterName: null,
      filterCountry: null,
      filteredList: [],
      alert: null,
      contactModal: false,
      contactList: [],
      filteredContacts: [],
      currentPage: 1,
      itemsPerPage: 20,
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  componentDidMount() {
    CompanyService.list().then((response) => {
      this.setState({ list: response, filteredList: response });
    });
    ContactService.list().then((response) => {
      this.setState({ contactList: response });
    });
  }

  hideDeleteAlert = () => {
    this.setState({
      alert: null,
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
          <ReactBSAlert
              warning
              style={{ display: "block" }}
              title="Are you sure?"
              onConfirm={() => this.delete(uniqueId)}
              onCancel={this.hideDeleteAlert}
              showCancel
              confirmBtnBsStyle="danger"
              confirmBtnText="Yes, delete it!"
              cancelBtnBsStyle="secondary"
              cancelBtnText="Cancel"
              btnSize=""
          >
            You won't be able to revert this!
          </ReactBSAlert>
      ),
    });
  };

  applyFilter = () => {
    const { list, filterName, filterCountry } = this.state;

    const filteredList = _.filter(list, (company) => {
      const nameMatches = filterName
          ? _.includes(_.toLower(company.legalName), _.toLower(filterName))
          : true;
      const countryMatches = filterCountry
          ? _.includes(_.toLower(company.country), _.toLower(filterCountry))
          : true;

      return nameMatches && countryMatches;
    });

    this.setState({ filteredList: filteredList, currentPage: 1 });
  };

  clearFilter = () => {
    this.setState({
      filteredList: this.state.list,
      filterName: null,
      filterCountry: null,
      currentPage: 1,
    });
  };

  displayContacts = (uniqueId) => {
    let filteredContacts = _.filter(
        this.state.contactList,
        (value) => value.company.uniqueId === uniqueId
    );
    this.setState({ filteredContacts: filteredContacts });
    this.toggleModal("contactModal");
  };

  delete(uniqueId) {
    this.setState({ alert: null });
    CompanyService.delete(uniqueId).then((response) => {
      this.notify(
          response.responseStatus.toLowerCase(),
          response.responseStatus,
          response.message
      );
      CompanyService.list().then((response) => {
        this.setState({ list: response, filteredList: response });
      });
    });
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
          <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
            <span data-notify="message">{message}</span>
          </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  paginate = (list) => {
    const { currentPage, itemsPerPage } = this.state;
    const startIndex = (currentPage - 1) * itemsPerPage;
    return list.slice(startIndex, startIndex + itemsPerPage);
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  renderPagination = () => {
    const { filteredList, currentPage, itemsPerPage } = this.state;
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);
    if (totalPages <= 1) return null;

    const pageNumbers = [...Array(totalPages).keys()].map((i) => i + 1);

    return (
        <nav aria-label="Company list pagination">
          <Pagination className="pagination justify-content-center mt-4">
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                  href="#prev"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1)
                      this.handlePageChange(currentPage - 1);
                  }}
              >
                <i className="fa fa-angle-left" />
              </PaginationLink>
            </PaginationItem>
            {pageNumbers.map((num) => (
                <PaginationItem key={num} active={num === currentPage}>
                  <PaginationLink
                      href={`#page-${num}`}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handlePageChange(num);
                      }}
                  >
                    {num}
                  </PaginationLink>
                </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink
                  href="#next"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      this.handlePageChange(currentPage + 1);
                  }}
              >
                <i className="fa fa-angle-right" />
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </nav>
    );
  };

  render() {
    let obj = this;
    const paginatedList = this.paginate(this.state.filteredList);

    return (
        <>
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert" />
          </div>
          <SimpleHeader
              name="List"
              parentName="Company"
              heading="XareGrwoth"
              style={{ display: CompanyPermissions.create() }}
          />
          {this.state.alert}
          <Container className="mt--6" fluid>
            <Row>
              <Col xl="12">
                <Card>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Companies List</h3>
                      </div>
                    </Row>
                    <Row>
                      <p style={{ fontStyle: "italic", color: "gray" }}>
                        Use the filters below to narrow down your search results.
                      </p>
                    </Row>
                    <Row>
                      <Col md="2">
                        <FormInput
                            name="filterName"
                            className="form-control-label"
                            id="companyName"
                            placeholder="Company Name"
                            type="text"
                            onChange={this.onChange}
                            label="Company"
                            value={this.state?.filterName || ""}
                        />
                      </Col>
                      <Col md="2">
                        <FormInput
                            name="filterCountry"
                            className="form-control-label"
                            id="countryName"
                            placeholder="Country Name"
                            type="text"
                            onChange={this.onChange}
                            label="Country"
                            value={this.state.filterCountry || ""}
                        />
                      </Col>
                      <Col sm={3} style={{ marginTop: "30px" }}>
                        <Button
                            size="md"
                            outline
                            color="default"
                            type="button"
                            onClick={this.applyFilter}
                        >
                          Apply Filter
                        </Button>
                        <Button
                            color="default"
                            size="md"
                            outline
                            type="button"
                            onClick={this.clearFilter}
                        >
                          Clear Filter
                        </Button>
                      </Col>
                    </Row>
                  </CardHeader>
                  <div style={{ overflow: "scroll", width: "100%" }}>
                    <Table
                        className="align-items-center table-flush"
                        responsive
                    >
                      <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th></th>
                        <th>Date Created</th>
                        <th>Legal Name</th>
                        <th>Country</th>
                        <th>Website</th>
                        <th>Company Types</th>
                        <th>Last Report Created</th>
                        <th />
                      </tr>
                      </thead>
                      <tbody className="list">
                      {paginatedList.map((value, index) => {
                        const globalIndex =
                            (this.state.currentPage - 1) *
                            this.state.itemsPerPage +
                            index +
                            1;
                        return (
                            <tr key={index}>
                              <td>{globalIndex}</td>
                              <td className="text-right">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                      color=""
                                      size="sm"
                                      className="btn-icon-only text-light"
                                  >
                                    <i className="fas fa-ellipsis-v" />
                                  </DropdownToggle>
                                  <DropdownMenu
                                      className="dropdown-menu-arrow"
                                      right
                                      container="body"
                                  >
                                    {/* Dropdown actions */}
                                    <DropdownItem
                                        style={{
                                          display: ContactPermissions.read(),
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.displayContacts(value.uniqueId);
                                        }}
                                    >
                                      View All Contacts
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/crm/contact/create/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Create Contact
                                    </DropdownItem>
                                    <DropdownItem
                                        style={{
                                          display: MeetingReportPermissions.create(),
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/crm/meetingReport/create/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Create Report
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/crm/summary/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      All summaries
                                    </DropdownItem>
                                    <DropdownItem
                                        style={{
                                          display: CompanyPermissions.read(
                                              value?.createdBy
                                          ),
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/crm/company/show/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Details
                                    </DropdownItem>
                                    <DropdownItem
                                        style={{
                                          display: CompanyPermissions.update(
                                              value?.createdBy
                                          ),
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/crm/company/edit/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Edit
                                    </DropdownItem>
                                    <DropdownItem
                                        style={{
                                          display: CompanyPermissions.delete(),
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.confirmDeleteAlert(value.uniqueId);
                                        }}
                                    >
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                              <td>{formatFrontendDate(value.dateCreated)}</td>
                              <td>{value.legalName}</td>
                              <td>{value.country}</td>
                              <td>{value.website}</td>
                              <td>
                                {value.companyTypeList &&
                                    value.companyTypeList.map((type, index) => (
                                        <h4
                                            key={index}
                                            className="badge badge-lg badge-primary"
                                        >
                                          {type}
                                        </h4>
                                    ))}
                              </td>
                              <td>{value.latestReportDate ? formatFrontendDate(value.latestReportDate) : 'N/A'}</td>
                            </tr>
                        );
                      })}
                      </tbody>
                    </Table>
                  </div>
                  {this.renderPagination()}
                </Card>
              </Col>
            </Row>

            <Modal
                className="modal-dialog-centered modal-lg"
                isOpen={this.state.contactModal}
                toggle={() => this.toggleModal("contactModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  Contacts
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("contactModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body">
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                  <tr>
                    <th className="sort" data-sort="name" scope="col">
                      #
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Full Name
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Company Name
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Contact Role
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Email Address
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Contact Number
                    </th>
                    <th scope="col"/>
                  </tr>
                  </thead>
                  <tbody className="list">
                  {this.state.filteredContacts.map(function (value, index) {
                    return (
                        <tr key={index}>
                          <td className="budget">{index + 1}</td>
                          <td className="budget">{value.fullName}</td>
                          <td className="budget">{value.company.legalName}</td>
                          <td className="budget">{value.contactRole}</td>
                          <td className="budget">{value.email || "N/A"}</td>
                          <td className="budget">{value.number || "N/A"}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                  color=""
                                  size="sm"
                                  className="btn-icon-only text-light"
                              >
                                <i className="fas fa-ellipsis-v"/>
                              </DropdownToggle>
                              <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                  container="body"
                              >
                                <DropdownItem
                                    onClick={(e) => {
                                      e.preventDefault();
                                      obj.props.history.push(
                                          `/crm/contact/show/${value.uniqueId}`
                                      );
                                    }}
                                >
                                  Details
                                </DropdownItem>
                                <DropdownItem
                                    onClick={(e) => {
                                      e.preventDefault();
                                      obj.props.history.push(
                                          `/crm/contact/edit/${value.uniqueId}`
                                      );
                                    }}
                                >
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                    onClick={(e) => {
                                      e.preventDefault();
                                      obj.confirmDeleteAlert(`${value.uniqueId}`);
                                    }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                    );
                  })}
                  </tbody>
                </Table>
              </div>
              <div className="modal-footer">
                <Button
                    className="ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("contactModal")}
                >
                  Close
                </Button>
              </div>
            </Modal>

          </Container>
        </>
    );
  }
}

export default CompanyList;
